import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { AddClockCardComponent } from '../add-clock-card/add-clock-card.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppService } from 'src/app/services/app/app.service';
import { TimeClockService } from 'src/app/services/time-clock/time-clock.service';
import { CommonService } from 'src/app/services/common/common.service';
@Component({
  selector: 'app-add-clock-card-model',
  templateUrl: './add-clock-card-model.component.html',
  styleUrls: ['./add-clock-card-model.component.scss']
})
export class AddClockCardModelComponent {
  public addForm!: FormGroup;
  constructor(private dialog: MatDialog, private fb: FormBuilder, private appService: AppService, private timeClockService: TimeClockService,
    private commonService: CommonService, @Inject(MAT_DIALOG_DATA) public dialogData: any, public dialogRef: MatDialogRef<AddClockCardModelComponent>,
  ) { }
  ngOnInit(): void {
    this.addForm = this.fb.group({
      name: ['', Validators.required]
    })
    if (this.dialogData && this.dialogData.id) {
      this.addForm.get('name')?.setValue(this.dialogData.name)
     
    }

  }
 
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(this.addForm, controlName, validationType);
  }
  onSubmit() {
    if (this.addForm.valid) {
      let obj = {
        name: this.addForm.get('name')?.value,
        id: ""
      }
      if (this.dialogData && this.dialogData.id) {
        obj.id = this.dialogData.id;
      }
      this.timeClockService.addCard(obj).subscribe({
        next: (success: any) => {
          // this.spinner.hide();
          //   this.isSpinnerLoading = false
          if (success.status == 200) {
            this.appService.showToastMessage('success', success.msg);
            // if id is available then edit is been done or else it is add functionality
            if (this.dialogData && this.dialogData.id) {
               this.onClose()
            }
            else {
      
              const dialogRef = this.dialog.open(AddClockCardComponent, Object.assign({
                width: '80%', height: '95%', maxWidth: '100vw', data:{ id:success.tc_id},
              }));
              dialogRef.afterClosed().subscribe(result => {
                this.onClose()
              });
            }
          }
        },
        error: (error: any) => {
          this.commonService.handleError(error);
        }
      })
    }
    else {
      this.addForm.markAllAsTouched();
    }
  }
  onClose(){
    this.dialogRef.close({ content_edited: true });
  }
}
